import React from 'react';
import {
    Image,
    View,
    Text,
    Linking,
    StyleSheet,
    ScrollView,
    ImageBackground,
    TouchableOpacity,
    ToastAndroid,
    ActivityIndicator,
} from 'react-native';

import Clipboard from "@react-native-community/clipboard"

import Colors from '../../constants/Colors';
import FontStyles from '../../constants/FontStyle';
import StyledButton from '../../components/StyledButton';
import FormikInput from '../../components/form/FormikInput';
import FormikSelectList from '../../components/form/FormikSelectList';
import GenericModal from '../../components/modals/GenericModal';
import StyledIcon from '../../components/StyledIcon';
import { AuthContext } from '../../contexts/auth/Store';
import { useNavigation } from '@react-navigation/native';
import { AnalyticsService } from '../../constants/Analytics';
import WalletNavCard from '../../components/wallet/NavCard';
import WalletHistoryCard from '../../components/wallet/HistoryCard';
import OTPInputView from '@twotalltotems/react-native-otp-input'
import GenericHeader from '../../components/headers/GenericHeader';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { Currency } from '../../constants/Utils';
import http from '../../utils/http';
// import SmsRetriever from 'react-native-sms-retriever';

const analytics = new AnalyticsService

function AccountScreen() {
    const navigation = useNavigation()

    const auth = React.useContext(AuthContext)
    const token = auth.getUserData.userToken
    const buyer = auth.getUserData.buyerData

    const [confirmBoxOpen, setConfirmBoxOpen] = React.useState(false)
    const hideConfirmModal = () => {
        setConfirmBoxOpen(false)
    }

    const buyAirtime = (values, actions) => {
        const form = new FormData()
        form.append('model', 'buyer')
        form.append('mobile_from', buyer.phone)
        form.append('mobile_to', values?.mobile)
        form.append('provider', values?.provider)
        form.append('amount', parseInt(values?.amount) * 100)

        http.post('spend/eyowo_initiate_vtu', form, token)
            .then(res => {
                if (res.code === 200) {
                    // ToastAndroid.show(res?.data?.message, ToastAndroid.LONG, ToastAndroid.BOTTOM)
                    actions.setSubmitting(false)
                    actiocns.resetForm()
                    navigation.navigate('WalletIndex')
                } else {
                    // ToastAndroid.show(res.message, ToastAndroid.LONG, ToastAndroid.BOTTOM)
                    // actions.setFieldError('passcode', res.message)
                    actions.setSubmitting(false)
                    console.warn(res)
                }
            })
            .catch(err => {
                // ToastAndroid.show('An error occured.', ToastAndroid.LONG, ToastAndroid.BOTTOM)
                actions.setSubmitting(false)
                console.warm(err)
            })
    }

    const copyAccount = async () => {
        let string = `${buyer.phone.split('').slice(1).join('')}`
        Clipboard.setString(string)
        let clipboardString = await Clipboard.getString()
        if (clipboardString === string) {
            // ToastAndroid.show('Copied!', ToastAndroid.LONG, ToastAndroid.BOTTOM)
        }
    }

    React.useEffect(() => {
        navigation.addListener('focus', () => {
            if (navigation.isFocused()) {
                analytics.logEvent('Viewed Wallet Acount', buyer)
                analytics.googleHelpers.setCurrentScreen('ViewedWalletAccount', 'ViewedWalletAccount')
            }
        })
        return () => {
            // cleanup
            navigation.removeListener('focus')
        };
    }, []);

    return (
        <>
            <GenericHeader title="My Account" />
            <ScrollView contentContainerStyle={styles.container}>
                <View style={[styles.subHeader]}>
                    <Text style={[styles.subHeaderText]}>Fund your account by sending money to the account number below</Text>
                </View>
                <View style={[styles.subHeader, { backgroundColor: Colors.whiteColor }]}>
                    <Text style={[
                        styles.subHeaderText,
                        FontStyles.gray,
                        FontStyles.size14,
                        FontStyles.lh16,
                    ]}>Account No.</Text>

                    <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
                        <Text style={[
                            FontStyles.size20,
                            FontStyles.lh24,
                            FontStyles.medium,
                            FontStyles.dark,
                            { marginTop: 6 }
                        ]}>{buyer?.phone.split('').slice(1).join('')}</Text>
                        <TouchableOpacity style={{ flexDirection: 'row' }} onPress={copyAccount}>
                            <Image source={require('../../assets/images/main/copy_icon.png')} style={{ width: 18, height: 18, alignSelf: 'center' }} />
                            <Text style={[
                                FontStyles.size12,
                                FontStyles.lh20,
                                FontStyles.medium,
                                FontStyles.default,
                                { marginLeft: 4, alignSelf: 'center' }
                            ]}>Copy</Text>
                        </TouchableOpacity>
                    </View>

                    <Text style={[
                        styles.subHeaderText,
                        FontStyles.gray,
                        FontStyles.size13,
                        FontStyles.lh18,
                        { marginTop: 16 }
                    ]}>Your Eyowo account number is the last 10 digits of your phone number</Text>
                </View>

                <View style={[styles.subHeader, { backgroundColor: Colors.whiteColor }]}>
                    <Text style={[
                        styles.subHeaderText,
                        FontStyles.gray,
                        FontStyles.size14,
                        FontStyles.lh16,
                    ]}>Account Name</Text>

                    <Text style={[
                        FontStyles.size16,
                        FontStyles.lh20,
                        FontStyles.normal,
                        FontStyles.dark,
                        { marginTop: 6 }
                    ]}>{buyer?.name}</Text>
                </View>

                <View style={[styles.subHeader, { backgroundColor: Colors.whiteColor }]}>
                    <Text style={[
                        styles.subHeaderText,
                        FontStyles.gray,
                        FontStyles.size14,
                        FontStyles.lh16,
                    ]}>Bank Name</Text>

                    <Text style={[
                        FontStyles.size16,
                        FontStyles.lh20,
                        FontStyles.normal,
                        FontStyles.dark,
                        { marginTop: 6 }
                    ]}>Eyowo</Text>
                </View>

                <View style={{padding: 16, flexGrow: 1, justifyContent: 'flex-end'}}>
                    <StyledButton
                        label="Go Back"
                        color="default"
                        size="lg"
                        action={() => navigation.goBack()}
                    />
                </View>
            </ScrollView>
        </>
    )
}

export default AccountScreen

const styles = StyleSheet.create({
    container: {
        flexGrow: 1,
        backgroundColor: Colors.shades._5,
    },
    subHeader: {
        padding: 16,
        // borderTopColor: Colors.shades._2,
        borderBottomColor: Colors.shades._6,
        // borderTopWidth: 1,
        borderBottomWidth: 1,
        borderStyle: 'solid'
    },
    subHeaderText: {},
    formContainer: {
        backgroundColor: Colors.whiteColor,
        paddingHorizontal: 16,
        paddingBottom: 30,
    },
    starWrapper: { flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'center', marginTop: 58 },
    star: { width: 24, height: 28, marginHorizontal: 4 },
})